import React from 'react';
// import PropTypes from 'prop-types';
import styles from './Title.styl';

const Title = props => {
  let title = '';
  let subTitle = '';

  switch (props.contactType) {
    case 'call':
      title = 'Call Your Reps';
      subTitle = 'Calling is the most effective way to cause change';
      break;
    case 'email':
      title = 'Email Your Reps';
      subTitle = 'Select who you would like to receive this email';
      break;
    case 'thanks':
      title = 'Thanks for helping protect the esa!';
      subTitle =
        'Donate now to help save the ESA and protect animals around the world.';
      break;
    default:
      title = 'Save the esa';
      subTitle =
        'The most effective way to help save the ESA is to call your members of Congress and urge them to protect the ESA.';
  }
  return (
    <div className={styles.titleWrapper} id="title">
      <h1 className={styles.mainHeader}>
        {title}
      </h1>
      <p className={styles.subtitle}>
        {subTitle}
      </p>
      {(props.zip && !props.contactType)
        ? <p className={styles.zipState}>
            {`${props.zip}`}
          </p>
        : ''}
    </div>
  );
};

export default Title;



// WEBPACK FOOTER //
// ./src/components/title/Title.js